/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable react/no-unknown-property */
import React, { FC } from "react";
import { INavLinks } from "components/HeaderNavBar/type";
import { ScrollToTopButton } from "../ScrollToTopButton/ScrollToTopButton";

import * as styles from "./SubFooter.module.scss";
import { SubFooterNav } from "../SubFooterNav/SubFooterNav";
const SearchInput = React.lazy(() => import("./SearchInput"));
import Logo30Years from "./30-years-logo.svg";
import { useLingui } from "@lingui/react/macro";

interface SubFooter {
  links: INavLinks;
  searchUrl?: string;
}

const SubFooter: FC<React.PropsWithChildren<SubFooter>> = ({
  links,
  searchUrl
}) => {
  const year = new Date().getFullYear();
  const { t } = useLingui();

  return (
    <div>
      <div className={styles.subFooterContainer}>
        <div className={styles.copyright}>
          <div className={styles.logo}>
            <img
              // @ts-ignore
              fetchpriority="low"
              src={Logo30Years}
              alt={"30 years"}
              loading="lazy"
              width={93}
              height={32}
            />
          </div>
          &copy; {year} SILVERSEA CRUISES LTD.
        </div>
        <SubFooterNav links={links} className={styles.subFooterNav} />

        <div data-content-piece="nav_search" className={styles.searchContainer}>
          {searchUrl && (
            <React.Fragment>
              <label htmlFor="sub-footer-search" className="sr-only">
                {t`Search input placeholder`}
              </label>
              <React.Suspense>
                <SearchInput searchUrl={searchUrl} />
              </React.Suspense>
            </React.Fragment>
          )}
          <ScrollToTopButton />
        </div>
      </div>
    </div>
  );
};

export default React.memo(SubFooter);
